/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 5
// module chunks = 0